import { HttpClient } from '../httpClient';
import StatesResponse from '../responses/statesResponse';

const httpClient = new HttpClient();

export const getStates = async () => {
  return httpClient.get<StatesResponse>({
    url: '/v1/states',
    requiresToken: true,
  });
};
